import { createBrowserHistory, History } from 'history';
import configureStore from './configureStore';
import { getBaseUrl } from "./BaseUrl";
import { WorkforceRoute } from "./AppState";
import { WorkforceOneUserLogOut } from './actions/WorkforceOneLoginActions';

const baseUrl = getBaseUrl();
const history: History<WorkforceRoute> = createBrowserHistory({ basename: baseUrl });
const store = configureStore(history);

export function LogOut() {
  store.dispatch(WorkforceOneUserLogOut())
}

export default store
